if (!customElements.get('powerful-ingredients-carousel')) {
  customElements.define(
    'powerful-ingredients-carousel',
    class PowerfulIngredientsCarousel extends HTMLElement {
      async connectedCallback() {
        this.slider = this.querySelector('[data-powerful-ingredients-slider]');

        if (!this.slider || this.slider.swiper) {
          return;
        }

        this.previousButton = this.querySelector('[data-powerful-ingredients-prev]');
        this.nextButton = this.querySelector('[data-powerful-ingredients-next]');
        this.pagination = this.querySelector('[data-powerful-ingredients-dots]');
        this.originalCount = Number(this.slider.getAttribute('data-original-count')) || 0;

        await this.waitForSwiper();

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: true,
          allowTouchMove: true,
          grabCursor: true,
          speed: 500,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.previousButton,
          },
          pagination: {
            el: this.pagination,
            type: 'bullets',
            clickable: true,
            bulletClass: 'powerful-ingredients__dot',
            bulletActiveClass: 'is-active',
            renderBullet: (index, className) => {
              if (this.originalCount > 0 && index >= this.originalCount) {
                return `<button class="${className}" type="button" tabindex="-1" aria-hidden="true" style="display:none"></button>`;
              }
              return `<button class="${className}" type="button" aria-label="Show ingredient ${index + 1}"></button>`;
            },
          },
          breakpoints: {
            0: {
              centeredSlides: true,
            },
            768: {
              centeredSlides: false,
            },
          },
          on: {
            slideChange: (swiper) => {
              if (!this.originalCount) {
                return;
              }

              const realIndex = swiper.realIndex % this.originalCount;
              const bullets = this.pagination
                ? this.pagination.querySelectorAll('.powerful-ingredients__dot')
                : [];

              bullets.forEach((bullet, index) => {
                bullet.classList.toggle('is-active', index === realIndex);
              });
            },
          },
        });
      }

      waitForSwiper() {
        return new Promise((resolve) => {
          if (window.Swiper) {
            resolve();
            return;
          }

          const checkSwiper = () => {
            if (window.Swiper) {
              resolve();
              return;
            }

            window.setTimeout(checkSwiper, 50);
          };

          checkSwiper();
        });
      }
    },
  );
}
